import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { GET_EVENTS_SUCCESS } from '../actions/eventActions';
import { GET_FUNERAL_HOMES_SUCCESS, CREATE_FUNERAL_HOME_SUCCESS, CREATE_FUNERAL_HOME_FAILURE, GET_FUNERAL_HOME_SUCCESS } from '../actions/funeralHomeActions';
import { LOGIN_USER_REQUEST_SUCCESS, LOGIN_USER_REQUEST_FAILURE,
  LOGOUT_USER, GET_USER_SUCCESS, INVITE_USER_SUCCESS, INVITE_USER_FAILURE, 
  RESET_USER_SUCCESS, RESET_USER_FAILURE
} from '../actions/userActions';

const setUser = () => {
  const token = localStorage.getItem("token"); 
  if (token) {
    return {
      token: token,
      loggedIn: true,
      error: null,
      user: null,
    }
  }

  return {
    token: null,
    loggedIn: false,
    error: null,
    user: null
  };
}

const initialState = {
  events: [],
  user: setUser(),
  funeralHomes: [],
  funeralHome: { error: false, success: false },
  funeralHomeViewing: {},
  userInvite: { error: false, success: false },
  userReset: { error: false, success: false },
}

function rootReducer(state, action) {
  switch(action.type) {
    case GET_EVENTS_SUCCESS:
      return { ...state, events: action.events }
    case GET_FUNERAL_HOMES_SUCCESS:
      return { ...state, funeralHomes: action.funeralHomes }
    case GET_FUNERAL_HOME_SUCCESS:
        return { ...state, funeralHomeViewing: action.funeralHome }
    case LOGIN_USER_REQUEST_SUCCESS:
      return { ...state, user: { token: action.token, loggedIn: true } }
    case LOGIN_USER_REQUEST_FAILURE:
      return { ...state, user: { token: null, error: action.error, loggedIn: false } }
    case LOGIN_USER_REQUEST_FAILURE:
      return { ...state, user: { token: null, error: null, loggedIn: false } }
    case GET_USER_SUCCESS: 
      return { ...state, user: { ...state.user, user: action.user } };
    case CREATE_FUNERAL_HOME_SUCCESS:
      return { ...state, funeralHome: { error: false, success: true, ...action.funeralHome } }
    case CREATE_FUNERAL_HOME_FAILURE:
      return { ...state, funeralHome: { ...state.funeralHome, success: false, error: true, message: action.message } }
    case INVITE_USER_SUCCESS:
      return { ...state, userInvite: { error: false, success: true } }
    case INVITE_USER_FAILURE:
        return { ...state, userInvite: { error: true, success: false, message: action.message } }
    case LOGOUT_USER: 
      return {
        token: null,
        loggedIn: false,
        error: null,
        user: null
      };
    case RESET_USER_SUCCESS:
      return { ...state, userReset: { error: false, success: true } };
    case RESET_USER_FAILURE:
      return { ...state, userReset: { error: true, success: false, message: action.message } };
    default:
      return state
  }
}

let allStoreEnhancers = compose(
  applyMiddleware(thunk)
);

if (window.devToolsExtension) {
  allStoreEnhancers = compose(allStoreEnhancers, window.devToolsExtension());
}

export default function configureStore() {
  const store = createStore(
    rootReducer, 
    initialState,
    allStoreEnhancers
  );
  return store;
}
